import Results from '../model/results';

/**
 * Results service
 * @type {{init: (function()), getResultsSvc: ResultsSvc.getResultsSvc}}
 */
export const ResultsSvc = {
  /**
   * Initialize results service
   */
  init() {
    this.resultsSvc = new Results();
  },

  /**
   * Get results service
   * @returns {Results | ResultsSvc}
   */
  getResultsSvc: function () {
    return this.resultsSvc;
  },
};



// WEBPACK FOOTER //
// results.service.js